import React from 'react';
import PublicPage from '../cms/PublicPage';

export default function ProspectusPage() {
  return <PublicPage slug="prospectus" />;
}
